/**
 *  Base Path and Configuration
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { linkBaseURL, dataEndpoint, GRID_COLUMNS, GRID_ROWS, GRID_CELLS };

/** Base URL of the Application  */
//var linkBaseURL = "http://localhost/kunstraum-backend/";
//var linkBaseURL = "https://eyerit.ch/kunstraum/demobackend/";
var linkBaseURL = "https://backend.kunst-raum.ch/";

/** Dat Endpoint */
var dataEndpoint = linkBaseURL + "api/getData.php?request=" + Math.floor(Math.random() * 1000000);

/** Grid Description */
var GRID_COLUMNS = 6;
var GRID_ROWS = 3;
var GRID_CELLS = GRID_COLUMNS * GRID_ROWS;